<div class="airt-container">
  <div class="airt-header">
    <h2>Narrative Impact Reports</h2>
    <button mat-raised-button color="primary" (click)="createNew()">
      <mat-icon>add</mat-icon> Create New Report
    </button>
  </div>

  <mat-form-field appearance="outline" class="centre-select">
    <mat-label>Select Centre</mat-label>
    <mat-select [(ngModel)]="selectedCentre" (selectionChange)="loadReports()">
      <mat-option *ngFor="let c of (centres$ | async)" [value]="c.centreCode">
        {{c.centreName}} ({{c.centreCode}})
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <mat-card *ngIf="reports.length === 0 && !loading && selectedCentre" class="empty-card">
    <mat-card-content>No reports found for this centre. Click "Create New Report" to start.</mat-card-content>
  </mat-card>

  <mat-table [dataSource]="reports" *ngIf="reports.length > 0" class="report-table mat-elevation-z2">
    <ng-container matColumnDef="centreName">
      <mat-header-cell *matHeaderCellDef>Centre</mat-header-cell>
      <mat-cell *matCellDef="let r">{{r.centreName || r.centreCode}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="quarterLabel">
      <mat-header-cell *matHeaderCellDef>Quarter</mat-header-cell>
      <mat-cell *matCellDef="let r">{{r.quarterLabel}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="periodLabel">
      <mat-header-cell *matHeaderCellDef>Period</mat-header-cell>
      <mat-cell *matCellDef="let r">{{r.periodLabel}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="submitType">
      <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
      <mat-cell *matCellDef="let r">
        <mat-chip [color]="r.submitType === 'final' ? 'primary' : 'accent'" selected>
          {{r.submitType | titlecase}}
        </mat-chip>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <mat-header-cell *matHeaderCellDef>Created</mat-header-cell>
      <mat-cell *matCellDef="let r">{{r.createdAt?.toDate?.() | date:'d MMM yyyy'}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
      <mat-cell *matCellDef="let r">
        <button mat-icon-button [routerLink]="['/reports/narrative-impact-report', r.id]" matTooltip="Edit">
          <mat-icon>edit</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table>
</div>
